import { render, staticRenderFns } from "./AddOrderForm.vue?vue&type=template&id=734634aa&scoped=true"
import script from "./AddOrderForm.vue?vue&type=script&lang=js"
export * from "./AddOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734634aa",
  null
  
)

export default component.exports